module.exports = __webpack_public_path__ + "static/img/mine1.68b7ac1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mine1.jpg
// module id = ldvD
// module chunks = 1